import React from "react";
import { Button } from "../misc/Button";
import { cn } from "../../utils/classMerger";

// A refresh that fails once the page has loaded (a network blip) keeps the page and says so;
// the full-page error is only for a first load that never arrived.
interface NicheRefreshNoteProps {
    onRetry: () => void;
    className?: string;
}

const NicheRefreshNote: React.FC<NicheRefreshNoteProps> = ({ onRetry, className }) => (
    <p role="status" className={cn("flex items-center gap-2 px-6 text-sm", className)}>
        <span className="text-[#d23600]">Couldn't refresh.</span>{" "}
        <Button type="button" size="sm" variant="outline" onClick={onRetry}>Try again</Button>
    </p>
);

export default NicheRefreshNote;
